var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-wrap"},[_c('div',{staticClass:"header bg-center"},[_c('h1',[_vm._v(_vm._s(_vm.regionName)+"溯源大数据")])])])}
var staticRenderFns = []

export { render, staticRenderFns }